import { DefaultState } from '@src/redux/types'

import * as TYPES from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [TYPES.COLOR_PALETTE]: DefaultState<`${typeof API.COLOR_PALETTE}`, 'get'>
} = () => ({
  [TYPES.COLOR_PALETTE]: defaultState(),
})
